<template>
	<IconButtonLayout class="thumbs-down-button">
		<template #default="{ iconClass }">
			<FontAwesomeIcon
				:class="iconClass"
				:icon="[ `fal`, `thumbs-down`]"
			/>
		</template>
	</IconButtonLayout>
</template>

<script>
import IconButtonLayout from "./IconButtonLayout.vue";

export default {
	name: "ThumbsDownButton",
	components: {
		IconButtonLayout,
	},
};
</script>

<style lang="scss" scoped></style>
